import Button from '@ingka/button';
import Tooltip from '@ingka/tooltip';
import { useDispatch } from 'react-redux';
import DataChart from '@ingka/ssr-icon/paths/data-chart';
import { openModal } from '../../../store/actions/modal/modal';
import type { AppThunkDispatch } from '../../../store';

export const ReportsLink = () => {
  const dispatch = useDispatch<AppThunkDispatch>();
  const onClick = () => {
    dispatch(openModal('ReportsDialog', {}));
  };
  return (
    <Tooltip
      describedById="reports-link-tooltip"
      interactiveCustomTrigger
      tooltipText="Select reports type"
      position="bottom"
    >
      <Button
        type="tertiary"
        aria-label="Reports"
        iconOnly
        size="small"
        onClick={onClick}
        ssrIcon={DataChart}
      />
    </Tooltip>
  );
};
